import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity9 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_9;
}

export default DirtRoadTileEntity9;
